import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from './services/auth/auth.service';
import { ROUTES } from './constants/routes';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'cafler';
  @ViewChild('div_dropdowns') div_dropdowns!: ElementRef;

  constructor(
    private router: Router,
    private authService: AuthService
  ) {}

  shouldShowNavbar(): boolean {
    return this.router.url !== `/${ROUTES.LOGIN}`;
  }

  async ngOnInit(): Promise<void> {
    await this.authService.initMsalInstance();
  }
}
